import React, { Fragment, useEffect } from 'react';
import QaGroup from '../../model/guideline/qaData';
import GuidelineData from '../../model/guideline/guidelineData';


interface ViewProps{
    qaGroupInfo: QaGroup[];
    guidelineInfo: GuidelineData;
    isError: boolean;
    isSuccess: boolean;
}

const ImageArrangement_1 = 1;
const ImageArrangement_2 = 2;

// 画像の配置と向きの表示切り替え
function GetImageArrangement(fileName: string)
{
    if(fileName == '') return null;

    // 横長画像かチェック
    if(fileName == 'neon_izumi_sd_jump.png')
    {
        return<>
            <div  style={{textAlign: 'center'}}>
                <img className='qa_image_oblong' src={`../assets/img/guidelineQa/${fileName}`} />
            </div> 
        </>
    }
    else
    {
        return<>
            <div  style={{textAlign: 'center'}}>
                <img className='qa_image' src={`../assets/img/guidelineQa/${fileName}`} />
            </div> 
        </>
    }
}

const View: React.FC<ViewProps> = (props: ViewProps) => {

    useEffect(() => {
        const scriptUrl = document.createElement('script');
        scriptUrl.type = 'text/javascript';
        scriptUrl.src = '../assets/js/common.min.js';
        document.body.appendChild(scriptUrl);
    },[]);

    // api通信が成功した時に更新
    // 該当の要素までスクロール
    useEffect(() => {
        if(window.location.hash)
        {
            const hash = window.location.hash;
            window.location.hash = "";
            window.location.hash = hash;
        }
    },[props.isSuccess]);

    return (
    <>
        <title>ガイドライン |PROJECT ZIRCON（プロジェクト ジルコン） 公式サイト</title>

        <header id="konami_hd">
            <div className="inner">
                <h1 className="konami_logo"><a href="https://www.konami.com/games/jp/ja/" target="_blank"><img src="../assets/img/hd_logo_konami.svg" alt="KONAMI" /></a></h1>
            </div>
        </header>
        <div className='wrapper'>
            <header id='incHd'></header>
            <main>
                <section className="subpage_header">
                    <div className="compass_wrap">
                        <p className="bg_compass"><img src="../assets/img/bg_compass_anime.svg" alt="" width="6058" height="6058" /></p>
                    </div>
                    <h2 className="ttl_deco_side">
                        <span className="en">GUIDELINE</span>
                        <span className="jp">二次創作のガイドライン</span>
                    </h2>
                </section>
                <div className="guideline_contents_area">
                {
                    props.isError == true ?
                    <>
                        <p style={{textAlign:'center'}}>ガイドラインの情報を取得できませんでした。<br />マスターデータを確認してください。</p>
                    </>
                    :
                    <>
                        <section className="guidline_anchor_area">
                            <div className="inner">
                                <h3 className="ttl">《 二次創作ガイドラインの簡単な解説 》</h3>
                                <div className="anchor_item">
                                    <dd>
                                        <div dangerouslySetInnerHTML={{__html: props.guidelineInfo.simpleExplanation}}></div>
                                    </dd>
                                </div>
                                <div className="btn_hexagon">
                                    <dd className="detail_ttl">詳しくはコチラ</dd>
                                    <a href="#guideline">二次創作のガイドライン</a>
                                </div>
                            </div>
                        </section>
                        <section className="qa_area">
                            <div className="inner">
                                {
                                    // Q&Aの表示
                                    props.qaGroupInfo.map((content, index) => {
                                        return <Fragment key={index}>
                                            <br /><br /><br />
                                            <h3 className='ttl' id={content.type}>《 {content.type} 》</h3>
                                            <div className='qa_item'>
                                                {
                                                    content.qaList.map((content, index) => {
                                                        return <Fragment key={index}>
                                                            <details open={index == 0 ? true : false} className='qa_accordion'>
                                                                <summary className='question'>{`Q. ${content.question}`}</summary>
                                                                <dt className='answer'>{`A. ${content.answer}`}</dt>
                                                    
                                                                {/* 画像配置パターン1の時、チェック */}
                                                                {
                                                                    content.arrangement == ImageArrangement_1 ? 
                                                                    GetImageArrangement(content.imageFile)
                                                                    : null
                                                                }
    
                                                                <dd className='qa_explanation' dangerouslySetInnerHTML={{__html: content.text}}></dd>
                                                            
                                                                {/* 画像配置パターン2の時、チェック */}
                                                                {
                                                                    content.arrangement == ImageArrangement_2 ?
                                                                    GetImageArrangement(content.imageFile)
                                                                    : null
                                                                }
                                                            </details>
                                                        </Fragment>
                                                    })
                                                }
                                            </div>
                                        </Fragment>
                                    })
                                }
                            </div>
                        </section>
                        <section id="guideline" className="guideline_area">
                            <div className="inner">
                                <br /><br />
                                <h3 className="ttl">「PROJECT ZIRCON」<br />著作物利用に関するガイドライン</h3>
                                <p className="revision_date">改定日 : {props.guidelineInfo.revisionDate}</p>
                                <div dangerouslySetInnerHTML={{__html: props.guidelineInfo.text}}></div>
                            </div>
                        </section>
                    </>
                }
                </div>
            </main>
            <footer id="incFt"></footer>
        </div>
    </>
    );
};

export default View;